import {field} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";

export class AccountPaymentReceiptReportData extends ReportData<AccountPaymentReceiptReportData> {
    @field paymentId: number;
    @field outletId: number;
}
